import { Config } from "./config.base";

const productionConfig: Config = {
  api: {
    baseUrl: "https://api-portal.meetfinex.com",
    timeout: 5000,
    retryAttempts: 3,
  },
  features: {
    enableCache: true,
    enableAnalytics: true,
  },
  auth: {
    tokenExpiration: 30,
    refreshTokenExpiration: 7,
  },
};

export default productionConfig;
